import { Directive, TemplateRef, ViewContainerRef } from '@angular/core'

import { ViewContextService } from '../services/view-context.service' // you define this

@Directive({
  selector: '[mmxConsoleOnly]',
  standalone: false,
})
export class ConsoleViewOnlyDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private contextService: ViewContextService,
  ) {
    if (this.contextService.isConsoleView()) {
      this.viewContainer.createEmbeddedView(this.templateRef)
    }
  }
}
